import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {SocialPostPreviewModalProps} from '@Modals/social-post-preview-modal/social-post-preview-modal.types';

export const openSocialPostPreviewModal = (props: SocialPostPreviewModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_POST_PREVIEW_MODAL,
      panelProps: props,
    })
  );
};
